import { useLocation } from 'react-router';
import { useAuthStore } from './store';

export type AccountTheme = 'asome-guitar';

/** Account branding belongs to private practice routes, never public/share pages. */
export function isAccountThemePath(pathname: string): boolean {
  return ['/studio', '/guitar-play'].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function useAccountTheme(): AccountTheme | null {
  const { pathname } = useLocation();
  return useAuthStore((state) => (
    state.status === 'authenticated'
    && state.user?.ui_theme === 'asome-guitar'
    && isAccountThemePath(pathname)
      ? 'asome-guitar'
      : null
  ));
}
